import React, { ReactNode, FC } from 'react';
import { CardContent, Card, useTheme } from '@mui/material';

type ICardContainer = {
  children: ReactNode;
};

const CardContainer: FC<ICardContainer> = ({ children }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        justifyContent: 'center',
        padding: '40px',
        bgcolor: 'background.default',
        borderRadius: '15px',
        shadow: '0 3px 6px 0 0',
        maxWidth: '550px',
        width: '550px',
        '@media (max-width: 768px)': {
          width: '400px',
        },
        boxSizing: 'border-box',
        [`${theme.breakpoints.down('sm')}`]: {
          marginTop: '60px',
        },
      }}
    >
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default CardContainer;
